import { render, staticRenderFns } from "./CollaboratorCardSection.vue?vue&type=template&id=04a4d64a&scoped=true&"
import script from "./CollaboratorCardSection.vue?vue&type=script&lang=js&"
export * from "./CollaboratorCardSection.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorCardSection.vue?vue&type=style&index=0&id=04a4d64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4d64a",
  null
  
)

export default component.exports